/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Toast_Expense_Merge_ErrorInputs */

const vi_toast_expense_merge_error = /** @type {(inputs: Toast_Expense_Merge_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Không gộp được khoản chi`)
};

/**

* @param {Toast_Expense_Merge_ErrorInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const toast_expense_merge_error = /** @type {((inputs?: Toast_Expense_Merge_ErrorInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Toast_Expense_Merge_ErrorInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_toast_expense_merge_error(inputs)
});